import { MainLayout } from "../../index.style";
import { LargeText, SmallText } from "../../styles/global/main.style";
import { TextBlock, TextWrapper } from "../../styles/pages/about-us.style";

const AboutUs = () => {
  return (
    <MainLayout>
      <div className="about-us-layout">
        <TextWrapper>
          <LargeText $isAboutUs={true}>About Us</LargeText>
          <TextBlock>
            <SmallText $isAboutUs={true}>
              Reliable Trucking Group (RTG) is a premier freight brokerage
              company that excels in connecting shippers with trusted carriers
              across the nation. We leverage advanced technology and industry
              expertise to deliver comprehensive logistics solutions that
              optimize supply chains and reduce transportation costs. Our
              extensive network of vetted carriers ensures reliable, efficient,
              and cost-effective freight movement for businesses of all sizes.
            </SmallText>
          </TextBlock>
          <LargeText $isAboutUs={true}>Mission</LargeText>
          <TextBlock>
            <SmallText $isAboutUs={true}>
              Our mission is to revolutionize freight brokerage by providing
              transparent, technology-driven logistics solutions that create
              lasting value for our partners. We are committed to building
              strong relationships with both shippers and carriers, ensuring
              seamless coordination of freight movement while maintaining the
              highest standards of service quality and reliability. Through
              innovative solutions and dedicated support, we aim to be the
              catalyst for our clients logistics success.
            </SmallText>
          </TextBlock>
          <LargeText $isAboutUs={true}>Vision</LargeText>
          <TextBlock>
            <SmallText $isAboutUs={true}>
              We aspire to be the industry's most trusted freight brokerage
              partner, recognized for our commitment to innovation,
              transparency, and exceptional service. Our vision encompasses
              creating a seamless logistics ecosystem where shippers and
              carriers thrive through optimized partnerships, advanced
              technology integration, and unparalleled support. By consistently
              delivering value and maintaining the highest standards of
              integrity, we aim to shape the future of freight transportation.
            </SmallText>
          </TextBlock>
        </TextWrapper>
        <img
          style={{ width: "562px" }}
          className="about-us-img"
          src="/images/about-us-img.jpg"
        />
      </div>
    </MainLayout>
  );
};

export default AboutUs;
